import datos from "src/services/datos";

export const getAlicuotasIVA = async (auth) => {
  const alicuotas_iva = new datos("alicuotas_iva");
  alicuotas_iva.addCondition("alicuotas_iva", "id", 0, ">");
  const response = await alicuotas_iva.get();

  const res = response.wsResponse.alicuotas_iva;
  // Si es un array se mantiene como estaba
  if (Array.isArray(res)) {
    var arr = res;
    // Si no es un array... primero se verifica que tenga valores ... si no los tiene
  } else if (typeof res === "undefined") {
    // se pasa un array vacio
    arr = [];
  } else {
    // si trae un solo elemento , es un objeto
    arr = [res]; // se lo convierte a array
  }
  return arr;
};
